const initialState = { events: [], isLoader: false, error: null, alertPopup: false, selectedEventId: null, selectedRange: null };
export default function calendar(state = initialState) {
  return state;
}
